import * as OM from '@/Model';

export class AddPrenotazioneCommentVm
{
    prenotazioneIdentifier: string;
    allegato: File;
    text: string;
    notifyUser: boolean
}

export class CalendarDay {
    date: Date;
    classes: string[];
    hours: CalendarHour[];
}

export class CalendarHour {
    hour: string;
    classes: string[];
}

export class AttachmentType {
  public static readonly Video = 'video'
  public static readonly Audio = 'audio'
  public static readonly Testo = 'testo'
  public static readonly Altro = 'altro'
}

export class ExceptionActionKeyBM
{
    public static readonly ExceptionActionKey_UserNotConfirmed = "ExceptionActionKey_UserNotConfirmed";
}